import { ELoanPurpose } from '@if/core/types'
import { Trans, useTranslation } from 'react-i18next'

interface Props {
  loanPurposeId: ELoanPurpose | undefined
  value: boolean
  onChange: (value: boolean) => void
}

const InvisalignQuestion = ({ loanPurposeId, value, onChange }: Props) => {
  const { t } = useTranslation()

  if (loanPurposeId !== ELoanPurpose.Dentistry) {
    return null
  }

  return (
    <div className="control-group">
      <label htmlFor="radiobuttons">
        <Trans
          i18nKey="invisalign.question"
          components={{ strong: <strong style={{ color: 'var(--accent-blue)' }} /> }}
        />
      </label>
      <div className="radiobuttons-wrap">
        <div className="radio-wrap">
          <input
            type="radio"
            id="isInvisalignYes"
            name="isInvisalign"
            value="yes"
            checked={value === true}
            onChange={() => onChange(true)}
          />
          <label htmlFor="isInvisalignYes">{t('common.yes')}</label>
        </div>
        <div className="radio-wrap">
          <input
            type="radio"
            id="isInvisalignNo"
            name="isInvisalign"
            value="no"
            checked={value === false}
            onChange={() => onChange(false)}
          />
          <label htmlFor="isInvisalignNo">{t('common.no')}</label>
        </div>
      </div>
    </div>
  )
}

export default InvisalignQuestion
